import "../scss/app.scss";

// SVGs to make into sprite, paths relative to app.js before move
var __svg__ = {
	path: "../svgs/sprite/*.svg",
	name: "../../authority/jinja2/svgs/sprite.svg"
};

import menuActions from "./includes/menuActions";
import initScoreDisplay from "./includes/scoreDisplay";
import initSignElapsedTime from "./includes/signElapsedTime";

document.addEventListener("DOMContentLoaded", function() {
	document.body.classList.remove("preload");
	menuActions();
	initScoreDisplay();
	initSignElapsedTime();
});
